/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Ecosystem_LabelInputs */

const en_home_ecosystem_label = /** @type {(inputs: Home_Ecosystem_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Business integrations`)
};

const lv_home_ecosystem_label = /** @type {(inputs: Home_Ecosystem_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biznesa integrācijas`)
};

/**
* | output |
* | --- |
* | "Business integrations" |
*
* @param {Home_Ecosystem_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const home_ecosystem_label = /** @type {((inputs?: Home_Ecosystem_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Ecosystem_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_home_ecosystem_label(inputs)
	return en_home_ecosystem_label(inputs)
});